import { product, productGroup, cart } from "./fragments";

export const productWithGroup = `
query productWithGroup($id: ID!) @inContext(country: ${window.Shopify.country}) {
  product(id: $id) {
    ${product}
    ${productGroup}
  }
}
`;

export const storefrontCartAdditionalData = `
  query storefrontCart($id: ID!) {
    cart(id: $id) {
      id
      lines(first: 100) {
        nodes {
          id
          quantity
          merchandise {
            ... on ProductVariant {
              title
              discountMessages: metafield(namespace: "custom", key: "discount_messages") {
                references(first: 15) {
                  nodes {
                    ... on Metaobject {
                      handle
                      markets: field(key: "markets") {
                        value
                      }
                      customerGroups: field(key: "customer_groups") {
                        references(first: 10) {
                          nodes {
                            ... on Metaobject {
                              value: field(key: "group") {
                                value
                              }
                            }
                          }
                        }
                      }
                      title: field(key: "title") {
                        value
                      }
                      bundleTitle: field(key: "bundle_title") {
                        value
                      }
                      message: field(key: "message") {
                        value
                      }
                      successMessage: field(key: "success_message") {
                        value
                      }
                      minimumQuantityTiers: field(key: "minimum_quantity_tiers") {
                        value
                      }
                      percentageOffTiers: field(key: "percentage_off_tiers") {
                        value
                      }
                    }
                  }
                }
              }
            }
          }
          discountAllocations {
            ... on CartAutomaticDiscountAllocation {
              title
              discountedAmount {
                currencyCode
                amount
              }
            }
          }
        }
      }
    }
  }
`;

export const cartDeliveryAddressesAdd = `
  mutation CartDeliveryAddressesAdd($id: ID!, $addresses: [CartSelectableAddressInput!]!) {
    cartDeliveryAddressesAdd(cartId: $id, addresses: $addresses) {
      userErrors {
        message
        code
        field
      }
      warnings {
        message
        code
        target
      }
      cart {
        ${cart}
      }
    }
  }
`;

export const storefrontCart = `
  query storefrontCart($id: ID!) {
    cart(id: $id) {
      ${cart}
    }
  }
`;

export const cartWithDeliveryGroups = `
  query cartWithDeliveryGroups($id: ID!) {
    cart(id: $id) {
      ${cart}
      ... DeliveryGroups @defer
    }
  }

  fragment DeliveryGroups on Cart {
    deliveryGroups(first: 10, withCarrierRates: true) {
      edges {
        node {
          id
          deliveryOptions {
            title
            handle
            estimatedCost {
              amount
              currencyCode
            }
          }
          selectedDeliveryOption {
            title
            handle
            estimatedCost {
              amount
              currencyCode
            }
          }
        }
      }
    }
  }
`;

export const cartDeliveryAddressesUpdate = `
mutation CartDeliveryAddressesUpdate($id: ID!, $addresses: [CartSelectableAddressUpdateInput!]!) {
  cartDeliveryAddressesUpdate(cartId: $id, addresses: $addresses) {
    userErrors {
      message
      code
      field
    }
    warnings {
      message
      code
      target
    }
    cart {
      ${cart}
    }
  }
}
`;
